import { Injectable } from '@angular/core';

export type TranslationContextMode = 'none' | 'url' | 'auth';

@Injectable({ providedIn: 'root' })
export class TranslationContextService {
  private mode: TranslationContextMode = 'none';
  private urlSuffix = '';

  private applied = new Map<string, string>();

  get suffix(): string {
    return this.mode === 'url' ? this.urlSuffix : '';
  }

  get isAuthMode(): boolean {
    return this.mode === 'auth';
  }

  private get currentKey(): string {
    return this.mode === 'url' ? this.urlSuffix : this.mode === 'auth' ? 'auth' : '';
  }

  markLoaded(lang: string): void {
    this.applied.set(lang, this.mode === 'url' ? this.urlSuffix : '');
  }

  markAuthApplied(lang: string): void {
    this.applied.set(lang, 'auth');
  }

  needsOverrides(lang: string): boolean {
    return this.applied.has(lang) && this.applied.get(lang) !== this.currentKey;
  }

  /**
   * Solo le lingue con override di un contesto `url` superato: quelli stanno dentro le
   * traduzioni scaricate, vanno buttate. Le altre non vanno invalidate - dimenticarle
   * qui significherebbe non applicargli mai gli override.
   */
  staleEmbeddedLangs(): string[] {
    return Array.from(this.applied.keys()).filter((lang) => {
      const key = this.applied.get(lang) ?? '';
      return this.needsOverrides(lang) && (key.startsWith('/') || key.startsWith('?'));
    });
  }

  forget(lang: string): void {
    this.applied.delete(lang);
  }

  setContext(mode: TranslationContextMode, urlSuffix = ''): boolean {
    if (mode === this.mode && urlSuffix === this.urlSuffix) {
      return false;
    }
    this.mode = mode;
    this.urlSuffix = urlSuffix;
    return true;
  }
}
